import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const SyncModelCvrSnapshotsRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>SyncModelCvrSnapshotsRootPage</h1>

      <LookupByUuidForm
        onSubmit={uuid =>
          navigate(
            atlasRoutes.syncModelCvrSnapshotsView({
              params: { syncModelCvrSnapshotId: uuid },
            }).path
          )
        }
      />
    </div>
  );
};
